import { AvailableMarketingChannelSchema } from "@redotech/redo-model/marketing/channel-eligibility";
import { ForceDiscountSchema } from "@redotech/redo-model/marketing/marketing-agent-decision/force-discount";
import {
  VanguardDecision,
  WriterDecision,
} from "@redotech/redo-model/marketing/marketing-agent-decision/marketing-agent-decision-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const generateMarketingAgentPreview = {
  name: "generateMarketingAgentPreview" as const,
  input: z.object({
    customerId: zExt.objectId(),
    availableChannels: z.array(AvailableMarketingChannelSchema).optional(),
    forceDiscount: ForceDiscountSchema.optional(),
  }),
  output: z.object({
    vanguardDecision: VanguardDecision,
    writerDecision: WriterDecision,
    vanguardThreadId: z.string(),
    writerThreadId: z.string(),
  }),
};
